import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild
} from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { Table } from "src/app/models/table/table.model";
import { TableField } from "src/app/models/table/table.field.model";
import { GridDataType } from "src/app/models/table/table.gtid.model";
import { TableService } from "src/app/services/table/table.service";
import { Subscription } from "rxjs";
//import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { InfoModalComponent } from "src/app/components/info-modal/info-modal.component";
import { TranslateService } from "@ngx-translate/core";
import { User } from "src/app/models/user.model";
import { MatTable } from "@angular/material/table";
import { ToastService } from "src/app/services/toast/toast.service";
import { ColumnTreeComponent } from "src/app/sections/tablas/tree-view/column-tree/column-tree.component";

@Component({
  selector: "app-tablas",
  templateUrl: "./tablas.component.html",
  styleUrls: ["./tablas.component.scss"],
})
export class TablasComponent implements OnInit, OnDestroy {
    subcriptions: Subscription[] = [];
    loading = false;
    tableCollection: Table[] = [];
    tableFieldCollection: TableField[] = [];
    selected: Table;
    tableSelected: string;
    enableTablasForm = false;
    formMode = '';
    datosAllTable = <GridDataType[]>[];
    dataToEdit = <GridDataType>{};
    browserLang: string;
    displayedColumns: string[] = [];
    dataSource = null;
    cleanData: any[];
    private paginator: MatPaginator;

    @ViewChild(MatTable, { static: false }) table: MatTable<GridDataType>;
    @ViewChild(MatPaginator, { static: false  }) set matPaginator(mp: MatPaginator) {
        this.paginator = mp;
        if (this.dataSource)
            this.dataSource.paginator = this.paginator;
    }
    tables = [0];


    constructor(
        private tableService: TableService, 
        public dialog: MatDialog, 
        private toastr: ToastService, 
        private translate: TranslateService) { 
    }
    
    loadGridData() {
        this.dataSource = new MatTableDataSource<GridDataType>(this.datosAllTable);
        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                return this.nestedFilterCheck(currentTerm, data, key);
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.dataSource.paginator = this.paginator;
    }

    nestedFilterCheck(search, data, key) {
        if (typeof data[key] === 'object') {
          for (const k in data[key]) {
            if (data[key][k] !== null) {
              search = this.nestedFilterCheck(search, data[key], k);
            }
          }
        } else {
          search += data[key];
        }
        return search;
      }

    refreshGrid() {
        if (this.table) {
            this.table.renderRows();
        }
    }

    ngOnInit() {
        if (!this.browserLang || this.browserLang.length <= 0) {
            let currentUser: User = JSON.parse(localStorage.getItem('loggedUser'));
            this.browserLang = (currentUser && currentUser.language) ? currentUser.language : this.translate.getDefaultLang();
        }

        this.subcriptions.push(this.translate.onLangChange.subscribe(eventLang => {
            this.browserLang = eventLang.lang;
        }));

        this.loading = true;
        this.getTableCollection();
        this.loading = false;
    }

    getTableCollection() {
        this.subcriptions.push(this.tableService.getAllTables().subscribe((data: Table[]) => {
            this.tableCollection = data;
        }));
    }

    changeSelection(event: MatSelectChange) {
        this.tableSelected = event.value;
        this.subcriptions.push(this.tableService.getTableFields(this.tableSelected).subscribe((data: TableField[]) => {
            this.tableFieldCollection = data;
            if (this.tableFieldCollection) {
                this.displayedColumns = [];               

                for (let index = 0; index < this.tableFieldCollection.length; index++) {
                    this.displayedColumns.push(this.tableFieldCollection[index].uuid);
                }

                this.datosAllTable = [];
                this.displayedColumns.push("actions");               
                this.getInitialData();                
            }
        }));
    }

    selectAgainCbo(select: string) {
        this.tableSelected = select;
        this.subcriptions.push(this.tableService.getTableFields(this.tableSelected).subscribe((data: TableField[]) => {
            this.tableFieldCollection = data;            
            if (this.tableFieldCollection) {
                this.displayedColumns = [];

                for (let index = 0; index < this.tableFieldCollection.length; index++) {
                    this.displayedColumns.push(this.tableFieldCollection[index].uuid);
                }

                this.displayedColumns.push("actions");
                this.loadGridData();
                this.refreshGrid();
            }

            this.displayedColumns.push("actions");
            this.loadGridData();
            this.refreshGrid();
          }))
        }

  confirmaddTable() {
    if (!this.tableSelected) {
      const options = {
        title: "TABLES.WARNING",
        message: "TABLES.ADD_WARNING",
        existingData: false,
      };

      this.dialog.open(InfoModalComponent, {
        height: "auto",
        width: "20%",
        data: options,
      });
    } else {
      this.enableTablasForm = true;
      this.formMode = "AGREGAR";
      this.dataToEdit = <GridDataType>{};
    }
  }

  cancelForm() {
    this.toggleTablasForm();
    if (this.tableSelected) {
      this.selectAgainCbo(this.tableSelected);
    }
  }

  deleteRecord(regSelected) {
    const options = {
      title: "TABLES.WARNING",
      message: "TABLES.DELETE_VALUE_MESSAGE",
      existingData: true,
    };

    const dialogRef = this.dialog.open(InfoModalComponent, {
      height: "auto",
      data: options,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.tableService
          .deleteTipoDatoTableData(this.tableSelected, regSelected.id)
          .subscribe((data) => {
            if (data && data.deleteTipoDatoTableData == 1) {
              let auxMessage = "";
              let auxMessage2 = "";
              this.translate
                .get("TABLES.DELETE_OK")
                .subscribe((value) => (auxMessage = value));
              this.translate
                .get("TABLES.SUCCESS")
                .subscribe((value) => (auxMessage2 = value));
              this.toastr.showSuccess(auxMessage, auxMessage2);

              this.getInitialData();
            } else {
              let auxMessage = "";
              let auxMessage2 = "";
              this.translate
                .get("TABLES.DELETE_OK")
                .subscribe((value) => (auxMessage = value));
              this.translate
                .get("TABLES.ERROR")
                .subscribe((value) => (auxMessage2 = value));
              this.toastr.showSuccess(auxMessage, auxMessage2);
              alert("Error al crear registro");
            }
          });
      }
    });
  }

  editRecord(regSelected) {
    this.formMode = "EDIT";
    this.dataToEdit = <GridDataType>regSelected;
    this.enableTablasForm = true;
  }

  saveEditForm(record) {
    this.getInitialData();
    this.toggleTablasForm();

    let auxMessage = "";
    let auxMessage2 = "";
    this.translate
      .get("TABLES.EDIT_OK")
      .subscribe((value) => (auxMessage = value));
    this.translate
      .get("TABLES.SUCCESS")
      .subscribe((value) => (auxMessage2 = value));
    this.toastr.showSuccess(auxMessage, auxMessage2);
  }

  saveAddForm(record) {
    //let dataToEdited = <GridDataType>{};
    this.getInitialData();

    this.toggleTablasForm();
    let auxMessage = "";
    let auxMessage2 = "";
    this.translate
      .get("TABLES.CREATE_OK")
      .subscribe((value) => (auxMessage = value));
    this.translate
      .get("TABLES.SUCCESS")
      .subscribe((value) => (auxMessage2 = value));
    this.toastr.showSuccess(auxMessage, auxMessage2);
  }

  toggleTablasForm() {
    this.enableTablasForm = !this.enableTablasForm;
  }

  ngOnDestroy(): void {
    this.subcriptions.forEach((s) => {
      s.unsubscribe();
    });
  }
  applyFilter(event: Event) {
    if (this.tableSelected) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  public getViewMore(event) {
    event.preventDefault();
    let uuidField = event.target.dataset.fieldUuid;
    let recordId = event.target.dataset.recordId;

    let objHtml = event.target || event.srcElement || event.currentTarget;
    let ele = <Element>objHtml;
    if (ele.matches(".ver_mas_nodos")) {
      this.seeMoreAction(recordId, uuidField);
    }

    return false;
  }

  public seeMoreAction(recordId: string, uuidField: string) {
    let data: any[];
    if (this.cleanData) {
      data = this.cleanData.where((t) => t.id == recordId);
      data.push({ uuid: uuidField, columns: this.tableFieldCollection });
    }
    const dialogRef = this.dialog.open(ColumnTreeComponent, {
      width: "40%",
      //height: '70%',
      data: data,
    });
  }

  private getInitialData() {
    this.subcriptions.push(
      this.tableService
        .getTableAllData(this.tableSelected, 0, 0, this.tableFieldCollection)
        .subscribe((data: Array<GridDataType>) => {
          this.datosAllTable = data;
          this.cleanData = data;
          this.loadGridData();
        })
    );
  }
}
